export default "__VITE_ASSET__FxszW8$6__"